/* eslint no-underscore-dangle: ["error", { "allow": ["_root"] }] */
// need this eslint rule since griddle now produces dangling vars...

import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory, Link } from 'react-router';
import Griddle, {
  plugins,
  RowDefinition,
  ColumnDefinition,
} from 'griddle-react';
import _ from 'lodash';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import Divider from 'material-ui/Divider';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { Dialog, FlatButton } from 'material-ui';

import ContactCard from '../../../components/ContactCard/ContactCard';

import caseInsensitiveSort from '../../../helpers/caseInsensitiveSort';

import classes from './Staff.scss';
import JoyRideStaff from '../../../components/JoyRideStaff/JoyRideStaff';

const renderAvatarAndName = data => {
  const values = _.split(data.value, ':-:');
  const name = values[0];
  const id = values[1];
  const avatarId = values[3];

  return (
    <ContactCard
      id={id}
      name={name}
      type="staff"
      avatarId={avatarId}
      displayType="normal"
    />
  );
};

const prepareData = dataArray => {
  const newData = [];
  _.forOwn(dataArray, data => {
    // create new object that will be handled by griddle
    let phone = '';
    if (
      typeof data.meta !== 'undefined' &&
      typeof data.meta.tel !== 'undefined' &&
      typeof data.meta.tel.value !== 'undefined' &&
      data.meta.tel.value !== null
    ) {
      phone = data.meta.tel.value;
    } else if (typeof data.phone !== 'undefined' && data.phone !== null) {
      phone = data.phone;
    }

    let section = '';
    if (typeof data.meta.section !== 'undefined') {
      section = data.meta.section.value;
    }

    let position = '';
    if (typeof data.meta.position !== 'undefined') {
      position = data.meta.position.value;
    }

    const person = `${data.name}:-:${data.id}:-:${data.avatar}:-:${data.avatar_id}`;

    if (typeof data.deleted_at === 'undefined' || data.deleted_at === null) {
      if (data.id && typeof data.name !== 'undefined') {
        newData.push({
          id: data.id,
          person,
          phone,
          email: data.email,
          position,
          section,
        });
      }
    }
  });
  return newData;
};

class Staff extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }

  componentDidMount() {
    this.props.fetchStaff();
    this.refresh = setTimeout(() => {
      this.forceUpdate();
    }, 1000);
    this.refreshSlow = setTimeout(() => {
      this.forceUpdate();
    }, 4000);
  }

  componentWillUnmount() {
    clearTimeout(this.refresh);
    clearTimeout(this.refreshSlow);
  }

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderOverflow = data => (
    <IconMenu
      iconButtonElement={
        <IconButton>
          <MoreVertIcon />
        </IconButton>
      }
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      <MenuItem
        primaryText="Bearbeiten"
        leftIcon={<EditIcon />}
        onTouchTap={e => this.props.setStaffForm(data.value)}
      />
      <Divider />
      <MenuItem
        primaryText="Mitarbeiter löschen"
        leftIcon={<DeleteIcon className="svg-icon-primary svg-icon-warning" />}
        key="delStaff"
        className="menu-primary"
        onClick={() => {
          this.setState({
            alert: (
              <Dialog
                actions={[
                  <FlatButton
                    label="Abbrechen"
                    primary
                    onTouchTap={this.handleAlertClose}
                  />,
                  <FlatButton
                    label="Löschen"
                    primary
                    onTouchTap={() => {
                      this.handleAlertClose();
                      this.props.deleteStaff(data.value);
                      browserHistory.push('/staff');
                    }}
                  />,
                ]}
                modal={false}
                open
                onRequestClose={this.handleAlertClose}
              >
                Mitarbeiter wirklich löschen?
              </Dialog>
            ),
          });
        }}
      />
    </IconMenu>
  );

  renderLinksMobile = dataArray => {
    const links = [];

    _.forOwn(dataArray, value => {
      links.push(
        <div key={`mobile_link_${value.id}`}>
          <ContactCard
            id={value.id}
            name={value.name}
            avatar={value.avatar}
            type="staff"
            displayType="normal"
          />
        </div>,
      );
    });

    return links;
  };

  render() {
    const props = this.props;
    const components = {
      NoResults: () => (
        <div>
          <p className="text-center">
            <small>Keine Mitarbeiter eingetragen.</small>
          </p>
        </div>
      ),
    };
    const sortProperties = [
      {
        id: 'person',
        sortAscending: true,
      },
    ];

    if (window.innerWidth < 767) {
      return (
        <div className="wrapper">
          <div>
            <h2 className={`${classes.zenHeader} gutter`}>Mitarbeiter</h2>

            <div className="mobile-list">
              {this.renderLinksMobile(props.staffs)}
            </div>
          </div>
        </div>
      );
    }

    const tableData = prepareData(props.staffs);
    return (
      <div className="wrapper JoyrideStaff">
        <div>
          <h2 className={`${classes.zenHeader} gutter`}>
            {tableData.length} Mitarbeiter -{' '}
            <Link to={'/user'} className="JoyrideStaffLink">
              Zur Benutzerverwaltung
            </Link>
          </h2>

          <Griddle
            data={tableData}
            plugins={[plugins.LocalPlugin]}
            pageProperties={{
              pageSize: 5000,
            }}
            components={components}
            sortProperties={sortProperties}
            sortMethod={caseInsensitiveSort}
          >
            <RowDefinition keyColumn="id">
              <ColumnDefinition
                id="id"
                title="ID"
                cssClassName="text-right"
                visible={false}
              />
              <ColumnDefinition
                id="person"
                title="Name"
                customComponent={renderAvatarAndName}
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition id="phone" title="Telefon" />
              <ColumnDefinition id="email" title="E-Mail" />
              <ColumnDefinition
                id="position"
                title="Position"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="section"
                title="Abteilung"
                sortMethod={caseInsensitiveSort}
              />
              <ColumnDefinition
                id="id"
                title=" "
                sortable={false}
                width={70}
                cssClassName="OverFlowButton text-right"
                customComponent={this.renderOverflow}
              />
            </RowDefinition>
          </Griddle>

          {this.state.alert}
        </div>
        <JoyRideStaff />
      </div>
    );
  }
}
Staff.propTypes = {
  fetchStaff: PropTypes.func.isRequired,
  setStaffForm: PropTypes.func.isRequired,
  deleteStaff: PropTypes.func.isRequired,
  staff: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  staffs: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
};
export default Staff;



// WEBPACK FOOTER //
// ./src/routes/Staff/components/Staff.js